import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

// types
import type { FieldProps } from './field';

interface FormGcaptchaProviderProps extends React.PropsWithChildren {
  formFields: FieldProps[];
  captchaKey: string | null;
}

export function FormGcaptchaProvider({
  formFields,
  captchaKey,
  children,
}: Readonly<FormGcaptchaProviderProps>) {
  const hasCaptcha = formFields?.some?.((field) => field.type === 'form_captcha');

  if (hasCaptcha && captchaKey) {
    return <GoogleReCaptchaProvider reCaptchaKey={captchaKey}>{children}</GoogleReCaptchaProvider>;
  }

  return <>{children}</>;
}
